import { mixpanel } from '@fiverr-private/obs';

const sendMixPanelEvent = (type, params) => {
    if (typeof MixpanelWrapper === 'object' && typeof MixpanelWrapper.trackEvent === 'function') {
        MixpanelWrapper.trackEvent(type, params);
    } else {
        mixpanel.track(type, params);
    }
};

export default sendMixPanelEvent;
